import Vue from 'vue';

const nameFromUserObject = value => {
  if (!value || (value && !(value.firstName || value.lastName))) {
    return '';
  }

  if (value.firstName === 'system' || value.lastName === 'system') {
    return 'System';
  }

  return value.lastName ? value.lastName : '' + ', ' + value.firstName ? value.firstName : '';
};
export default nameFromUserObject;

Vue.filter('nameFromUserObject', nameFromUserObject);
